module.exports = __webpack_public_path__ + "static/media/ChannelSong.Tamil.2f125078.jpg";